import { ReactNode } from 'react';
import { Dayjs } from 'dayjs';

export const ActionTypes = {
  SET_VALUE: 'SET_VALUE',
  SET_VALUES: 'SET_VALUES'
} as const;

export interface IReportValuesProps {
  children: ReactNode;
}

export type IState = {
  first_name: string | null | undefined;
  last_name: string | null | undefined;
  date_of_birth: Dayjs | null;
  report_date: Dayjs | null;
  email: string | null | undefined;
  report: string | null | undefined;
  doctor_info?: string | null;
  lang?: string | null;
  icd: {
    title: string;
    id: string;
  }[];
};

type SetValue = {
  type: typeof ActionTypes.SET_VALUE;
  data: { key: string; value: string | Dayjs };
};

type SetValues = {
  type: typeof ActionTypes.SET_VALUES;
  data: IState;
};

export type Action = SetValue | SetValues;

export type Dispatch = (action: Action) => void;
